/*******************************************************************************
Toggle Custom Checkbox State
Checks or unchecks a custom checkbox.
*******************************************************************************/

export default function toggleCheckbox(e) {
    const $cb = $(e.currentTarget);
    if ($cb.hasClass('checked')) {
        $cb.removeClass('checked').find('input[type="checkbox"]').prop('checked', false).change();
    }
    else {
        $cb.addClass('checked').find('input[type="checkbox"]').prop('checked', true).change();
    }
}
